// extracted by mini-css-extract-plugin
export default {"mainModal":"qmsmodal_mainModal__V+vOh","previewContainer":"qmsmodal_previewContainer__BZOVG"};